/**
 * 헤더 햄버거 ↔ #site-drawer 패널 토글
 * 닫힘: 컬럼 마스크 역순 스태거 후 패널 제거 (_drawer.scss `is-closing`)
 */
export function initSiteDrawer(): void {
    const toggle = document.querySelector<HTMLElement>(".no-header__hamburger");
    const drawer = document.getElementById("site-drawer");
    if (!toggle || !drawer) return;

    /** max transition-delay(0.21s) + clip-path duration(0.72s) + 여유 */
    const DRAWER_CLOSE_MS = 960;
    let closeTimer: ReturnType<typeof setTimeout> | null = null;

    const applyOpenState = (open: boolean): void => {
        drawer.setAttribute("aria-hidden", open ? "false" : "true");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        if (open) {
            document.documentElement.setAttribute("data-drawer-open", "true");
        } else {
            document.documentElement.removeAttribute("data-drawer-open");
        }
        document.body.classList.toggle("drawer-open", open);
    };

    const setOpen = (open: boolean): void => {
        if (open) {
            if (closeTimer !== null) {
                window.clearTimeout(closeTimer);
                closeTimer = null;
            }
            drawer.classList.remove("is-closing");
            drawer.classList.add("is-open");
            applyOpenState(true);
            return;
        }

        if (!drawer.classList.contains("is-open")) return;
        if (drawer.classList.contains("is-closing")) return;

        drawer.classList.add("is-closing");
        closeTimer = window.setTimeout(() => {
            closeTimer = null;
            drawer.classList.remove("is-open", "is-closing");
            applyOpenState(false);
        }, DRAWER_CLOSE_MS);
    };

    const closeBtn = drawer.querySelector<HTMLButtonElement>(".drawer__close");
    closeBtn?.addEventListener("click", () => {
        setOpen(false);
    });

    toggle.addEventListener("click", () => {
        setOpen(!drawer.classList.contains("is-open"));
    });

    toggle.addEventListener("keydown", (e: KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen(!drawer.classList.contains("is-open"));
        }
    });

    document.addEventListener("keydown", (e: KeyboardEvent) => {
        if (e.key === "Escape" && drawer.classList.contains("is-open")) {
            setOpen(false);
        }
    });

    drawer.addEventListener("click", (e) => {
        if ((e.target as HTMLElement).closest(".drawer__link")) {
            setOpen(false);
        }
    });
}
